import { Flex } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { useMutation } from 'react-query';
import BrandButton from '../../../components/brandButton/BrandButton';
import { CustomToast } from '../../../components/toast/CustomToast';
import { mutateFunction } from '../../../libs/apis';

const permissions = [
  { key: 'can_manage_dashboard', label: 'Dashboard' },
  { key: 'can_manage_users', label: 'Users' },
  { key: 'can_manage_offers', label: 'Offers' },
  { key: 'can_manage_brands', label: 'Brands' },
  { key: 'can_manage_subscriptions', label: 'Subscriptions' },
  { key: 'can_manage_deleted_users', label: 'Deleted Users' },
  { key: 'can_manage_post_reports', label: 'Post Reports' },
  { key: 'can_manage_adverts', label: 'Adverts' },
  { key: 'can_manage_deals', label: 'Deals' },
];

export default function SubAdminForm({ subAdmin, onSubmitSuccess, onClose }) {
  const isEdit = !!subAdmin;

  const { mutate, isLoading } = useMutation(mutateFunction);
  const { addToast } = CustomToast();

  const [formData, setFormData] = useState({
    email: '',
    first_name: '',
    last_name: '',
    ...permissions.reduce((acc, p) => ({ ...acc, [p.key]: false }), {}),
    can_manage_dashboard : true

  });

  useEffect(() => {
    if (isEdit) {
      const { user, ...rest } = subAdmin;
      setFormData({
        email: user?.email || '',
        first_name: user?.first_name || '',
        last_name: user?.last_name || '',
        ...permissions.reduce((acc, p) => ({ ...acc, [p.key]: rest[p.key] ?? false }), {}),
        can_manage_dashboard : true
      });
    }
  }, [subAdmin]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
      can_manage_dashboard : true
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
        if(isLoading) return
        if(!formData.first_name || !formData.last_name || !formData.email){
            addToast({ message: `Please add fill email and names` }, 'warning');
            return
        }
        const url = isEdit ? `subadmins/${subAdmin.id}` : 'subadmins';
        const method = isEdit ? 'PUT' : 'POST';
        const _formData = {...formData}
        if(isEdit){
            delete _formData.email
            delete _formData.last_name
            delete _formData.first_name
        }
        mutate(
            {
                key: url,
                method,
                data: _formData,
            },
            {
            onSuccess(res) {
                addToast(res);
                onSubmitSuccess(res)
            },
            onError(e) {
                addToast({ message: `Sub admin was not created, ${e || ''}` }, 'error');
            },
            },
        );
    } catch (err) {
        console.error(err);
        addToast({ message: `Could not create sub admin` }, 'error');
    }
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="space-y-6 p-4 bg-white"
    >
      <h2 className="text-xl font-bold">{isEdit ? 'Edit Sub-Admin' : 'Create Sub-Admin'}</h2>

      {!isEdit && (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              name="email"
              className="mt-1 block w-full border rounded px-3 py-2"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">First Name</label>
            <input
              type="text"
              name="first_name"
              className="mt-1 block w-full border rounded px-3 py-2"
              value={formData.first_name}
              onChange={handleChange}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Last Name</label>
            <input
              type="text"
              name="last_name"
              className="mt-1 block w-full border rounded px-3 py-2"
              value={formData.last_name}
              onChange={handleChange}
              required
            />
          </div>
        </>
      )}

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Permissions</label>
        <div className="grid grid-cols-2 gap-2">
          {permissions.map(({ key, label }) => (
            <label key={key} className="flex items-center space-x-2">
              <input
                type="checkbox"
                name={key}
                checked={formData[key]}
                onChange={handleChange}
                className="form-checkbox"
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
      </div>

      <Flex gap={10} className="mt-6 justify-center items-center">
            <BrandButton
                isLoading={isLoading}
                text={isEdit ? 'Update Sub-Admin' : 'Create Sub-Admin'}
                onClick={handleSubmit}
                type="submit"
                variant="md"
                bgColor="brand.primary"
                color="#fff"
                fontSize="14px"
                borderRadius={4}
                px={4}
                minW="180px"
                _hover={{ background: "brand.primary" }}
            />
            <BrandButton
                text="Close"
                onClick={onClose}
                minW="180px"

            />
        </Flex>
      <button
        type="submit"
        className="bg-blue-600 hidden text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        {isEdit ? 'Update Sub-Admin' : 'Create Sub-Admin'}
      </button>
    </form>
  );
}
